import { render, staticRenderFns, recyclableRender, components } from "./after_sale.vue?vue&type=template&id=c0c8656a&"
var renderjs
import script from "./after_sale.vue?vue&type=script&lang=js&"
export * from "./after_sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/my_shop/after_sale.vue"
export default component.exports